import { watch } from 'vue'

/**
 * Composable for scroll to top functionality
 * Provides smooth scroll behavior for page navigation and form submissions
 */
export function useScrollToTop () {
  /**
   * Scrolls the window to the top of the page
   * @param {Object} options - Scroll options
   * @param {string} options.behavior - Scroll behavior: 'smooth' or 'auto' (default: 'smooth')
   */
  const scrollToTop = (options = {}) => {
    const { behavior = 'smooth' } = options

    // Try smooth scroll first
    window.scrollTo({
      top: 0,
      left: 0,
      behavior
    })

    // Immediate fallback for older browsers and mobile devices
    setTimeout(() => {
      if (window.scrollY !== 0) {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }
    }, 0)
  }

  /**
   * Watch a ref and scroll to top when it becomes true
   * Useful for watching showForm or similar boolean refs in admin components
   * @param {Ref<boolean>} refToWatch - The reactive reference to watch
   */
  const watchAndScroll = refToWatch => {
    watch(refToWatch, (newValue, oldValue) => {
      if (newValue === true && oldValue === false) {
        scrollToTop()
      }
    })
  }

  return {
    scrollToTop,
    watchAndScroll
  }
}
